import {axiosPartnerPlatformInstance} from "../../ServerApiManager";
import {AxiosResponse} from "axios";

type Variables = {
  username: string;
  signInDetails: {authFlowType: string; loginId: string};
};

type Data = undefined;

export const loginAudit = async (variables: Variables): Promise<Data> => {
  const result = await axiosPartnerPlatformInstance.post<Data, AxiosResponse<Data>>(`auth/login`, {
    username: variables.username,
    sign_in_details: variables.signInDetails,
  });
  return result.data;
};
